import styled from 'styled-components';

// Read with the link or button it sits in, so a screen reader announces the new tab before the
// context changes. Positioned out of the flow: the global .visually-hidden class is not, so as an
// inline child it would still take up width in the line.
const Hidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const NewTabNote = () => <Hidden> (opens in a new tab)</Hidden>;

export default NewTabNote;
